import { render, staticRenderFns } from "./DashboardLayoutMyaffilAnnoncer.vue?vue&type=template&id=c89d7d80&"
import script from "./DashboardLayoutMyaffilAnnoncer.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMyaffilAnnoncer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMyaffilAnnoncer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports